import Vue from 'vue'
import store from '@/store'
import { Ctv } from '@/utils'

// 站点模板
Vue.directive('belongSite', {

  inserted: function(el, binding) {
    const parentNode = el.parentNode
    let hasPermission = null

    new Ctv(store.state.app.siteInfo, {
      success: v => {
        this.initScroll()
        hasPermission = binding.value === v.templateRoute
        if (!hasPermission) {
          el.parentNode && el.parentNode.removeChild(el)
        } else {
          parentNode.appendChild(el)
        }
      },
      fail: (first, instance) => {
        if (!first) {
          instance.handle(store.state.app.siteInfo)
        }
      }
    })

    if (!hasPermission) {
      el.parentNode && el.parentNode.removeChild(el)
    }
  }
})

